export const socialLinks = {
  discord: "https://discord.gg/BURFPPdwX2",
  twitter: "https://x.com/blackesblanco",
  youtube: "https://www.youtube.com/@BlackDaBlanco",
  tiktok: "https://www.tiktok.com/@blackesblanco"
} as const;

export type SocialKey = keyof typeof socialLinks;

export const socialProfiles: Array<{
  key: SocialKey;
  name: string;
  description: string;
  buttonLabel: string;
  ariaLabel: string;
  tone: string;
}> = [
  {
    key: "discord",
    name: "Discord",
    description: "Unete a la comunidad, recibe anuncios y participa en proximos eventos.",
    buttonLabel: "Unirme",
    ariaLabel: "Unirse al Discord oficial de DarkLabs",
    tone: "from-indigo-500/18 to-violet-500/10 text-indigo-200"
  },
  {
    key: "twitter",
    name: "X",
    description: "Noticias, avances y anuncios rapidos de DarkLabs.",
    buttonLabel: "Seguir en X",
    ariaLabel: "Abrir el perfil de DarkLabs en X",
    tone: "from-slate-200/14 to-white/5 text-slate-100"
  },
  {
    key: "youtube",
    name: "YouTube",
    description: "Videos, eventos, avances y contenido relacionado con nuestros proyectos.",
    buttonLabel: "Ver canal",
    ariaLabel: "Abrir el canal de DarkLabs en YouTube",
    tone: "from-red-500/18 to-red-950/10 text-red-200"
  },
  {
    key: "tiktok",
    name: "TikTok",
    description: "Clips, momentos de eventos y contenido corto de la comunidad.",
    buttonLabel: "Ver TikTok",
    ariaLabel: "Abrir el perfil de DarkLabs en TikTok",
    tone: "from-cyan-400/16 to-pink-500/10 text-cyan-100"
  }
];

export const darkLabsAbout = [
  "DarkLabs es un estudio y comunidad creativa enfocada en desarrollar eventos, minijuegos y experiencias competitivas dentro de Minecraft. Creamos sistemas, herramientas y formatos personalizados para organizar competiciones, conectar jugadores y ofrecer eventos con una identidad propia.",
  "Nuestro objetivo es construir experiencias cuidadas, competitivas y accesibles, combinando desarrollo, diseno, produccion de eventos y tecnologia para crear proyectos que puedan crecer junto a su comunidad."
] as const;

